import React, {useEffect} from "react";
import {useAuth} from "../../contexts/AuthContext";
import {Badge, Dropdown, DropdownButton, Navbar} from "react-bootstrap";

export const Leadtubadminnavbar = () => {
    const { currentUser } = useAuth();


    useEffect(() => {

    }, [])


    return(
        <div className="mb-2">
            <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                    Leadtubadmin
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item href="/leadtub-admin-dashboard">Dashboard</Dropdown.Item>
                    <Dropdown.Item href="/leadtub-admin-onboard">On-boarding</Dropdown.Item>
                    <Dropdown.Item href="/leadtub-admin-users">Användare</Dropdown.Item>
                    <Dropdown.Item href="/leadtub-admin-companies">Företag</Dropdown.Item>
                    <Dropdown.Item href="/leadtub-admin-leads">Leads</Dropdown.Item>
                    <Dropdown.Item href="/leadtub-admin-log">Admin-Log</Dropdown.Item>
                    <Dropdown.Item href="/leadtub-admin-app">App-info</Dropdown.Item>

                </Dropdown.Menu>
            </Dropdown>
        </div>
    )
}
